<template>
  <div class="inline-form-group">
    <omnia-time-select
      start="00:00"
      end="23:59"
      :step="step"
      title="Start time"
      :isDisabled="disabled"
      :value="startTime"
      @onTimeSelected="onStartTimeSelection"
    />
    &ndash;
    <omnia-time-select
      end="23:59"
      :step="step"
      :start="endTimeStart"
      title="End time"
      :isDisabled="disabled"
      :value="endTime"
      @onTimeSelected="onEndTimeSelection($event)"
    />
  </div>
</template>

<script>
import { debounce } from "lodash";
import { compareTime, nextTime } from "@/globals/globals.js";
import OmniaTimeSelect from "@/components/OmniaTimeSelect.vue";

export default {
  name: "TimeRangeSelector",

  props: {
    disabled: { required: true },
    start: { required: true },
    end: { required: true },
    step: { required: true },
  },

  components: {
    OmniaTimeSelect,
  },

  data() {
    return {
      startTime: "",
      endTime: "",
      endTimeStart: "00:00",
    };
  },

  watch: {
    start(start) {
      this.startTime = start ? start : "";
    },

    end(end) {
      this.endTime = end ? end : "";
    },

    startTime: debounce(function (startTime) {
      if (!startTime) {
        return;
      }

      if (this.endTime && compareTime(startTime, this.endTime) !== -1) {
        this.endTime = "";
      }

      this.endTimeStart = nextTime(startTime, "00:05");
    }, 300),
  },

  methods: {
    onStartTimeSelection(startTime) {
      this.startTime = startTime;
      this.$emit("timeRangeSelected", {
        start: this.startTime,
        end: this.endTime,
      });
    },

    onEndTimeSelection(endTime) {
      this.endTime = endTime;
      this.$emit("timeRangeSelected", {
        start: this.startTime,
        end: this.endTime,
      });
    },
  },
};
</script>
